import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { DateHelper } from '../../helpers/date.helper';
import { Schedule } from '../../types/schedule.type';
import { SchedulerMissingItem } from '../../types/scheduler/scheduler-missing-item.type';

@Injectable({ providedIn: 'root' })
export class SchedulerEmulatorApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/scheduler-emulator`;
  }

  async runEmulator(tenantId: string, from: Date, to: Date): Promise<void> {
    await this.get<void>(`run-emulator/${DateHelper.formatApiDateOnly(from)}/${DateHelper.formatApiDateOnly(to)}${this.getTenantParameter(tenantId)}`);
  }

  async getSchedulerEmulatorProcessScheduleResourcesMissing(tenantId: string, date: Date): Promise<Schedule> {
    const result = await this.get<Schedule>(`missing-sessions/resources/schedule/resources/${DateHelper.formatApiDateOnly(date)}${this.getTenantParameter(tenantId)}`);
    ApiConversionHelper.convertSchedule(result);
    return result;
  }

  async getSchedulerEmulatorProcessScheduleUsersMissing(tenantId: string, date: Date): Promise<Schedule> {
    const result = await this.get<Schedule>(`missing-sessions/resources/schedule/users/${DateHelper.formatApiDateOnly(date)}${this.getTenantParameter(tenantId)}`);
    ApiConversionHelper.convertSchedule(result);
    return result;
  }

  async getSchedulerEmulatorMissingItems(tenantId: string, date: Date): Promise<SchedulerMissingItem[]> {
    const result = await this.get<SchedulerMissingItem[]>(`missing-items/${DateHelper.formatApiDateOnly(date)}${this.getTenantParameter(tenantId)}`);
    return result;
  }
}
